'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import handleChange from 'Components/Forms/Functions/handleChange';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Select from 'Components/Forms/Elements/Select';
import BookingModuleRow from 'Components/Lists/Rows/BookingModuleRow';
import Dashboard from 'Components/Lists/Dashboard';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { front_urls, URL } from 'Shared/Routes';
import { action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const {
  app,
  moment,
  qwest
} = window;
const header = [{
  name: 'customer.lastname',
  label: 'Nom du client',
  sortable: false
}, {
  name: 'created_at',
  label: 'Date de commande',
  sortable: false
}, {
  name: 'date',
  label: 'Date de réservation',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}, {
  name: 'created_by.lastname',
  label: 'Admin',
  sortable: false
}, {
  name: 'amount',
  label: 'CA TTC',
  sortable: false
}, {
  name: 'coworking_space.etablishment_id',
  label: 'Etablissement'
}, {
  name: 'PDF',
  sortable: false
}, {
  name: 'actions',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class BookingsModuleDashboardPage extends Component {
  state = {
    status_messages: {},
    created_start_date: "",
    created_end_date: "",
    start_date: "",
    end_date: "",
    user: "all",
    select_key: uniqid(),
    user_options: [{
      value: "all",
      label: "Tous "
    }]
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchAllAdmin();
  }
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    handleChange.bind(this)({
      e,
      value: value,
      name
    });
    if (value && name === 'created_start_date') {
      component.setState({
        created_end_date: moment(value).add(1, 'day').format('YYYY-MM-DD')
      });
    } else if (value && name === 'start_date') {
      component.setState({
        end_date: moment(value).add(1, 'day').format('YYYY-MM-DD')
      });
    }
  };
  fetchAllAdmin = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllUsers'), {
      role: "admin"
    }).then(function (xhr, response) {
      let user_options = (response.data || []).map(function (user) {
        const option = {
          value: user.id,
          label: user.lastname + " " + (user.firstname || '')
        };
        return option;
      });
      user_options.unshift({
        value: "all",
        label: "Tous"
      });
      component.setState({
        user_options: user_options,
        select_key: uniqid(),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const can__export = isTrue(app.state.session?.user?.can_export_data);
    let filters = {
      created_start_date: state.created_start_date,
      created_end_date: state.created_end_date,
      start_date: state.start_date,
      end_date: state.end_date,
      admin: state.user,
      source: 'offline'
    };
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "R\xE9servations"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-right"
    }, /*#__PURE__*/React.createElement(Button, {
      href: URL('NewModuleBooking', front_urls),
      className: bemit('c-flat-btn', ['primary']) + " u-margin-right-5",
      component: Link
    }, "Cr\xE9er une r\xE9servation"), isTrue(can__export) ? /*#__PURE__*/React.createElement(Button, {
      href: "/export/commande-b2c-offline?start_date=" + (state.start_date || "") + '&end_date=' + (state.end_date || "") + '&created_start_date=' + (state.created_start_date || "") + '&created_end_date=' + (state.created_end_date || "") + '&admin=' + (state.user || ""),
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank",
      component: Link
    }, "Exporter les commandes") : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['created_start_date'] || "",
      className: "cutom-date-picker",
      name: "created_start_date",
      label: "Date de commande (d\xE9but)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['created_end_date'] || "",
      className: "cutom-date-picker",
      name: "created_end_date",
      label: "Date de commande (fin)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de consommation (d\xE9but)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de consommation (fin)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: state.user_options,
      defaultValue: state.user_options[0]?.value,
      onChange: component.handleChange,
      key: state.select_key,
      value: state['user'],
      name: "user",
      type: "text",
      label: "Commerciaux",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "Booking",
      url: action('getAllBookings'),
      header: header,
      fields: fields,
      component: BookingModuleRow,
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
